import GroupRoomContainer from './GroupRoomContainer';
export default GroupRoomContainer;
